import s from './Services.module.scss';
import { ReactComponent as ArrowRight } from 'images/new-icons/arrow-right.svg';
import Card from './Card/Card';
import TopSpecialists from './TopSpecialists/TopSpecialists';
import PostedVideo from './PostedVideo/PostedVideo';
import { useNavigate } from 'react-router-dom';
import useGetServicesBySalonId from 'sdk/hooks/salon/useGetServicesBySalonId';
import { useTranslation } from 'react-i18next';

const Services = ({ data, setStep }) => {

    const {t} = useTranslation() as any;
    
  const navigate = useNavigate();
  const { data: services } = useGetServicesBySalonId(data?.id);

  const handleSeeAll = (path: string) => {
    const scrollPosition = Math.floor(window.scrollY);
    navigate(path, {
      state: {
        tab: 3,
        restoreScroll: true,
        scrollPosition: scrollPosition,
        fromSeeAll: true,
      },
    });
  };

  return (
    <div className={s.services}>
      <div className={s.services_title}>
        <div className={s.services_title_title}>{t('Services')}</div>
        <div
          className={s.services_title_see}
          onClick={() => handleSeeAll(`/salon/${data?.id}/services`)}
        >
          <div>See All</div>
          <ArrowRight />
        </div>
      </div>
      <div className={s.services_cards}>
        <Card data={{ ...data, services: services }} />
      </div>
      <div className={s.services_title}>
        <div className={s.services_title_title}>{t('Top specialists')}</div>
        <div
          className={s.services_title_see}
          onClick={() => handleSeeAll(`/salon/${data?.id}/specialists`)}
        >
          <div>See All</div>
          <ArrowRight />
        </div>
      </div>
      <TopSpecialists
        salonId={data?.id}
      />
      <div className={s.services_title}>
        <div className={s.services_title_title}>{t('Posted Video')}</div>
        <div
          className={s.services_title_see}
          onClick={() => handleSeeAll(`/salon/${data?.id}/videos`)}
        >
          <div>{t('See All')}</div>
          <ArrowRight />
        </div>
      </div>
      <PostedVideo salonId={data?.id} />
    </div>
  );
};

export default Services;
